import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from 'semantic-ui-react'
import DairyService from '~/api/services/dairy'
import { StyledImageWrapper } from '~/pages/Users/User/Edit/style'
import { UserEl } from './style'
import Drawer from '~/components/Drawer'
import { handleErrors } from '~/utils/helpers'

interface ShowUserProps {
  userId?: string
  handleHiddenDrawer: () => void
}

const defaultImage = '/assets/default.png'

const ShowUser: React.FC<ShowUserProps> = (props) => {
  const { userId, handleHiddenDrawer } = props
  const { t } = useTranslation()
  const [isBusy, setIsBusy] = useState(false)
  const [userData, setUserData] = useState(null)

  useEffect(() => {
    if (userId) {
      fetchShowData()
    }
  }, [userId])

  async function fetchShowData() {
    setIsBusy(true)
    try {
      const response = await DairyService.showUserData(userId)
      setUserData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  function renderContent() {
    return <UserEl.StyledGrid columns={1}>
      <Grid.Row columns={1}>
        <Grid.Column>
          <StyledImageWrapper>
            <img src={defaultImage} />
          </StyledImageWrapper>
        </Grid.Column>
      </Grid.Row >
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Name')}:</label>
          <div>{userData?.name}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Role')}:</label>
          <div>{userData?.roleLabel}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Email')}:</label>
          <div>{userData?.email}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Phone number')}:</label>
          <div>{userData?.phonePrefixCountry ? `${userData?.phonePrefixCountry} ${userData?.phoneNumber}` : ''}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <label>{t('Mobile number')}:</label>
          <div>{userData?.mobilePrefixCountryPhoneCode ? `${userData?.mobilePrefixCountryPhoneCode} ${userData?.mobileNumber}` : ''}</div>
        </Grid.Column>
      </Grid.Row>
    </UserEl.StyledGrid>
  }

  return <Drawer
    onHide={() => handleHiddenDrawer()}
    header={t('Show user')}
    isVisible={Boolean(userId)}
    isBusy={isBusy}
    content={renderContent()}
    closeOnEscape
  />

}
export default ShowUser